'use client';

import SearchBar from 'components/controls/search-bar';
import { useRouter } from 'src/navigation';
import {
	useState,
	type KeyboardEventHandler,
	type MouseEventHandler,
	type ChangeEventHandler,
} from 'react';
import { cleanURLParams } from 'helpers/search/cleanURLParams';

const SEARCH_PAGE = `/press-releases`;
const DEBOUNCE_TIME = 250;

const PressSearchWrapper = ({ initialQuery, searchParams }: Props) => {
	const [query, setQuery] = useState(initialQuery);
	const router = useRouter();

	const updateSearchParams = (searchQuery: string) => {
		const newSearchParams = cleanURLParams({
			...searchParams,
			q: searchQuery,
			page: undefined,
		});
		if (newSearchParams) {
			router.push(`${SEARCH_PAGE}?${new URLSearchParams(newSearchParams)}`);
		}
	};

	const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
		const query = e.target.value ?? '';
		updateSearchParams(query);
		setQuery(query);
	};
	const handleKeyDown: KeyboardEventHandler = (e) =>
		e.key === 'Enter' && updateSearchParams(query);
	const handleButtonClick: MouseEventHandler<HTMLButtonElement> = () =>
		updateSearchParams(query);

	return (
		<SearchBar
			debounceTimeout={DEBOUNCE_TIME}
			initialQuery={initialQuery}
			placeholderText="Type to search&hellip;"
			onKeyDown={handleKeyDown}
			onChange={handleChange}
			onButtonClick={handleButtonClick}
		/>
	);
};

type Props = {
	initialQuery: string;
	searchParams: { [key: string]: string | string[] };
};

export default PressSearchWrapper;
